import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AppService } from 'src/app/appservice.service';

@Component({
  selector: 'app-changepassowrd',
  templateUrl: './changepassowrd.component.html',
  styleUrls: ['./changepassowrd.component.css']
})
export class ChangepassowrdComponent implements OnInit {

  userForm: FormGroup;
  isAddress = false;
  isSubmitting = false;

  constructor(public dialogRef: MatDialogRef<ChangepassowrdComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public service: AppService) {
    this.userForm = new FormGroup({
      username: new FormControl(data.name),
      key: new FormControl(),
      newpassword: new FormControl(),
      confirmpassword: new FormControl()
    });
  }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onSubmit() {
    try {
      this.isSubmitting = true;
      if (this.userForm.valid) {
        if (this.userForm.controls.newpassword.value === this.userForm.controls.confirmpassword.value) {
          this.service.getRequestData('changepassword', this.userForm.value).subscribe((data) => {
            console.log(data);
            if (data.Success) {
              this.data.name = this.userForm.controls.username.value;
              this.dialogRef.close(data.data);
              this.service.sendMessage('SaveSuccess');
            } else {
              this.service.sendMessage(data.message);
            }
          },
            (err) => {
              console.log('Change Password failed : ' + err);
              this.service.sendMessage('Oops');
            });
        } else {
          this.service.sendMessage('User.ConfirmPasswordNotMatch');
        }
      } else {
        this.service.sendMessage('User.FillAllDetails');
      }
    } catch (ex) {
      console.log(ex);
      this.service.sendMessage('Oops');
    } finally {
      this.isSubmitting = false;
    }
  }

}

export interface DialogData {
  name: string;
}
